// search-state.service.ts
import { Injectable } from '@angular/core';

const KEY = 'MOC_SEARCH_STATE';

@Injectable({ providedIn: 'root' })
export class MocSearchStateService {
  set(value: any) {
    sessionStorage.setItem(KEY, JSON.stringify(value));
  }
  get(): any | null {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  }
  clear() {
    sessionStorage.removeItem(KEY);
  }
}
